module.exports = __webpack_public_path__ + "static/media/McLaren_P1.de18dc87.png";